<template>
  <body>
    <div class="header">
      HR モンスター
    </div>
    <div class="form" v-if="isResetTokenLoading&&!isResetTokenExpired&&!success">
      <p><span class="mdi mdi-loading mdi-spin mdi-48px"></span></p>
    </div>
    <div class="form" v-if="!isResetTokenLoading&&isResetTokenExpired&&!success">
      <b-field>
        <b style="font-size: 20px;">パスワード再発行画面</b>
      </b-field>
      <b-field
        label="新しいパスワード"
        class="input-form">
        <b-input type="password"
                 icon="lock"
                 minlength="8"
                 v-model="oldPassword"
                 password-reveal></b-input>
      </b-field>
      <b-field
        label="新しいパスワード(確認)"
        class="input-form">
        <b-input type="password"
                 icon="lock"
                 minlength="8"
                 v-model="newPassword"
                 password-reveal></b-input>
      </b-field>
      <b-field style="margin-top: 50px;">
        <button class="button is-primary"
                style="border-radius: 20px;"
                v-if="disabled" :disabled="disabled">変更する</button>
        <button class="button is-primary"
                style="border-radius: 20px;"
                @click="changePassword()"
                v-if="!disabled" :disabled="disabled">変更する</button>
      </b-field>
    </div>
    <div class="form" v-if="!isResetTokenLoading&&!isResetTokenExpired&&!success">
      <b-field>
        <b style="font-size: 1.0em;">パスワード再発行画面</b>
      </b-field>
      <b-field style="margin-top: 5vh;">
        <b-message type="is-danger" style="font-size: 0.85em;" has-icon>
          大変申し訳ございません。パスワードの期限が過ぎているか、既に使用されております。下記ボタンより再発行してください。
        </b-message>
      </b-field>
      <b-field style="margin-top: 5vh;">
        <button class="button is-primary"
                style="border-radius: 20px;"
                @click="$store.dispatch('auth/setPRModal')">再発行する</button>
      </b-field>
      <ModalPasswordReset></ModalPasswordReset>
    </div>
    <div class="form" v-if="success">
      <p>パスワード変更完了しました。</p>
      <p>以下をクリックし、ログインしてください。</p>
      <button class="button" style="margin-top: 5vh; border-radius: 20px; color: white;">
        <router-link to="/login">ログインページへ</router-link>
      </button>
    </div>
    <div class="footer">
      新しいパスワードを入力してください。このURLは24時間以内のみ有効となります。
      無効となった場合は再取得してください。
    </div>
  </body>
</template>

<script>
import { mapState } from 'vuex'
import ModalPasswordReset from '@/components/ui/ModalPasswordReset'
export default {
  name: 'PasswordResetView',
  componentName: 'PasswordResetView',
  components: {
    ModalPasswordReset
  },
  computed: {
    ...mapState('auth', ['success', 'error', 'isResetTokenExpired', 'isResetTokenLoading', 'isModalPasswordReset']),
    disabled () {
      return this.newPassword === '' || this.oldPassword === '' || this.oldPassword !== this.newPassword || this.oldPassword.length < 8 || this.newPassword.length < 8
    }
  },
  data () {
    return {
      newPassword: '',
      oldPassword: ''
    }
  },
  methods: {
    changePassword () {
      console.debug('*** Start *** changePassword')
      this.$store.dispatch('auth/reCreatePassword', {password: this.newPassword, id: this.$route.params.uuid})
      console.debug('*** End *** changePassword')
    }
  },
  created () {
    console.debug('*** Start *** created')
    this.$store.dispatch('auth/checkToken', this.$route.params.uuid)
    console.debug('*** End *** created')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background-color: #313E4D;
  text-align: left;
  height: 15vh;
  padding: 5vh;
  color: white;
  font-size: 30px;
}
.form {
  display: inline-block;
  text-align: center;
  overflow-y: scroll;
  margin-top: 30px;
  height: 60vh;
  width: 80vw;
  min-height: 300px;
  max-width: 500px;
  padding: 30px;
  background-color: #F8F8F8;
  border-radius: 10px;
}
.input-form {
  text-align: left;
  margin-top: 40px;
}
.footer {
  position: absolute;
  bottom: 0;
  background-color: #313E4D;
  height: 10vh;
  width: 100vw;
  padding: 2vh;
  overflow-y: scroll;
  color: white;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/PasswordReset/PasswordResetView.vue